module.exports = __webpack_public_path__ + "bin/36b3b20f4ed4335799f3b4dbc321ddba.png";